import axios from 'axios';
import serviceConfig from "./serviceConfig";
import { getToken } from "./../auth/utils";
import { checkStatusCode } from "./services";

const queryString = require('query-string');
const svConfig = { ...serviceConfig };

const loadWithdrawFirst = async () => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;

    let config = {
        method: svConfig.method_get,
        url: '/customer/payment/withdraw/channel',
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: {}
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result: result,
            code: code
        };
    }
}

const confirmWithdraw = async (data) => {
    const {
        amount,
        bankId,
        channel,
        channelId
    } = data;

    let myJson = {
        amount,
        bankId,
        channel,
        channelId
    };

    let config = {
        method: svConfig.method_post,
        url: "/customer/payment/withdraw/channel",
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: queryString.stringify(myJson)
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result: result,
            code: code
        };
    }
}

const checkWithdraw = async (depositId) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;

    let myJson = {
        "id": depositId
    };

    let config = {
        method: svConfig.method_post,
        url: '/customer/payment/withdraw/check',
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: queryString.stringify(myJson)
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result: result,
            code: code
        };
    }
}

const loadWithdrawRank = async () => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;

    let config = {
        method: svConfig.method_get,
        url: `/common/section/withdraw`,
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: {}
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result } = dataPromise;

    if (checkStatusCode(code)) {
        if (code === 0) {
            return result;
        }
        else {
            return [];
        }
    }
}

export {
    loadWithdrawFirst,
    confirmWithdraw,
    checkWithdraw,
    loadWithdrawRank
};